
export default {
  'ModalHeader.Header.CloseButton': ({ }, stateManager) => {
    // setting empty string will close the modal
    stateManager.setToggleWebCam('')  
  }
}
